
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIURL } from '../Constant/API_Urls';
import { SharedHttpClientService } from './shared-http-client.service';
import { UrlsService } from './urls.service';
import { ConstantService } from './constant-service';
import { UserService } from './user.service';
import { GridService } from './grid.service';
import { map } from 'rxjs/operators';

@Injectable(
  {providedIn: 'root'}
)
export class DataService {
 public roeSelectedRecords:any=[];
  async init() {

  }
  
  constructor(
    private router: Router,
    private constantService: ConstantService,
    private sharedHttpClientService: SharedHttpClientService,
    private userService: UserService,
    private gridService: GridService,
    private urlsService: UrlsService,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  getLastReportedClientDate() {
    this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.DatesForClientData,
        this.userService.getActiveMPID()));

  }

  getLastReportedDate() {
    return this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.LastExecutionDate,
        this.userService.getActiveMPID()))
  }

  getRouteData(DefaultFilterArray: any, Limit: any, pageName: any,exceptionId?: number | any) {
    return this.gridService.getData(
      APIURL.Routes,
      DefaultFilterArray,
      Limit,
      "",
      pageName,
      exceptionId
    );
  }

  getOrderData(DefaultFilterArray: any, Limit: any, pageName: any, exceptionId?: any) {
    return this.gridService.getData(
      APIURL.Orders,
      DefaultFilterArray,
      Limit,
      "",
      pageName,
      exceptionId
    );
  }

  getTradeData(DefaultFilterArray: any, Limit: any, pageName: any, exceptionId?: number | any) {
    return this.gridService.getData(
      APIURL.Trades,
      DefaultFilterArray,
      Limit,
      "",
      pageName,
      exceptionId
    );
  }

  getCATData(DefaultFilterArray: any, Limit: any, event: any, pageName: any) {
    return this.gridService.getData(
      APIURL.CAT_ROE_Viewer,
      DefaultFilterArray,
      Limit,
      event,
      pageName
    );
  }

  getOrderIDList( fromdate: any, todate: any, orderID: any, symbol: any, pageName: any) {
    return this.gridService.getOrderIDList(
      APIURL.Order_Viewer_OrderList,
      fromdate,
      todate,
      orderID,
      symbol,
      pageName
    );
  }

  getOrderViewerCATData( fromdate: any, todate: any, orderID: any, symbol: any, limit: any, pageName: any) {

    let Data = {
        "mpid": this.userService.getActiveMPID(),
        "fromdate": fromdate,
        "todate": todate,
        "orderID": orderID,
        "symbol": symbol,
        "startLimit": limit.Start + "",
        'endLimit': limit.End + "",
        'pageName': pageName
    };
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Order_Viewer_CAT_data), Data)
    .pipe(map((response: Response) => {
      return response;
  }));
}

getOrderViewerOrderData( fromdate: any, todate: any, orderID: any, symbol: any, limit: any, pageName: any) {

  let Data = {
      "mpid": this.userService.getActiveMPID(),
      "fromdate": fromdate,
      "todate": todate,
      "orderID": orderID,
      "symbol": symbol,
      "startLimit": limit.Start + "",
      'endLimit': limit.End + "",
      'pageName': pageName
  };
  return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Order_Viewer_Order_data), Data)
  .pipe(map((response: Response) => {
    return response;
}));
}

getOrderViewerTradeData( fromdate: any, todate: any, orderID: any, symbol: any, limit: any, pageName: any) {

  let Data = {
      "mpid": this.userService.getActiveMPID(),
      "fromdate": fromdate,
      "todate": todate,
      "orderID": orderID,
      "symbol": symbol,
      "startLimit": limit.Start + "",
      'endLimit': limit.End + "",
      'pageName': pageName
  };
  return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Order_Viewer_Trade_data), Data)
  .pipe(map((response: Response) => {
    return response;
}));
}


getOrderViewerRouteData( fromdate: any, todate: any, orderID: any, symbol: any, limit: any, pageName: any) {

  let Data = {
      "mpid": this.userService.getActiveMPID(),
      "fromdate": fromdate,
      "todate": todate,
      "orderID": orderID,
      "symbol": symbol,
      "startLimit": limit.Start + "",
      'endLimit': limit.End + "",
      'pageName': pageName
  };
  return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Order_Viewer_Route_data), Data)
  .pipe(map((response: Response) => {
    return response;
}));
}


  runScript(URL: string) {
    return this.sharedHttpClientService.get(URL)
      .pipe((response: any) => {
        return response;
      });
  }

  setStartValidationProcess(FileType: string,reportDate: any) {
    if(FileType=="")
        FileType="CAT";
    let tempURl = this.urlsService.setAPIURl(
      APIURL.FileUploadMove) + FileType + "/" + this.userService.getActiveMPID()+ "/" +reportDate + "/" + this.userService.getUid() + "/" + "move";
    return this.sharedHttpClientService.post(
      tempURl, {
      })
      .pipe(map((response: Response) => {
        return response;
    }));
  }

  getFileDownload(url: string,fileName: any,folder: any,reportDate: any) {
    return this.sharedHttpClientService.postPlainText(url, {
      "filename": fileName,
      "folder": folder,
      "date": reportDate,
      "mpid": this.userService.getActiveMPID(),
      "user": this.userService.getUserName(),
    })
  }

  formAddressDetails(AddressGridColumns: { db_columnname: any; }[], responseObject: { [x: string]: any; }, AddressDataObject: { [x: string]: any; }[]) {
    let addressColumns = AddressGridColumns.map(({ db_columnname }) => db_columnname);
      for(let j=1; j<=AddressDataObject.length; j++) {
        responseObject['addr'+j+'_addrLine1'] = AddressDataObject[j-1][addressColumns[0]];
        responseObject['addr'+j+'_addrLine2'] = AddressDataObject[j-1][addressColumns[1]];
        responseObject['addr'+j+'_addrLine3'] = AddressDataObject[j-1][addressColumns[2]];
        responseObject['addr'+j+'_addrLine4'] = AddressDataObject[j-1][addressColumns[3]];
        responseObject['addr'+j+'_city'] = AddressDataObject[j-1][addressColumns[4]];
        responseObject['addr'+j+'_regionCode'] = AddressDataObject[j-1][addressColumns[5]];
        responseObject['addr'+j+'_countryCode'] = AddressDataObject[j-1][addressColumns[6]];
        responseObject['addr'+j+'_postalCode'] = AddressDataObject[j-1][addressColumns[7]];
      }
  }

  checkRowExistanceInList(rowDataObject: any, selectedRecordsList: any[], compareKey: any) {
    if(selectedRecordsList.length > 0 && selectedRecordsList.filter((element: any) => element[compareKey] === rowDataObject[compareKey]).length===0) {
      selectedRecordsList = [];
      selectedRecordsList[0] = (rowDataObject);
    }
    return selectedRecordsList;
  }

  trimValue(value:any){
    if(value !== null && value !== undefined){
      return value = value.trim().length == 0 ? null : value.trim(); 
    }
    return value;
  }

  removeNullValueObj(obj:any) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }

  /* Check any Empty values Object available in given Object-Array */
  hasAnyEmptyObjectInObjectArray(objArray: any) {
    if(objArray.length > 0) {
      for(let i=0; i<objArray.length; i++) {
        if(Object.keys(this.removeNullValueObj(objArray[i])).length === 0) {
          return false;
        }
      }
    }
    return true;
  }

  /* Receive Encoded URL Parameters from any Screen's URL and decode them */
  getViewerEncodedURLParameters() {
    let urlEncodedParams: object | any = new Object();

    this.activatedRoute.queryParams.subscribe((params) => {
      if(Object.keys(params).length > 0) {
        try{
           urlEncodedParams = JSON.parse(atob(Object.keys(params)[0]));
        } catch(error){
        }
       
       }
    });

    /* Set Active MPID for the Screen */
    if(urlEncodedParams && urlEncodedParams["activeMPID"]) {
      this.userService.setActiveMPID(urlEncodedParams["activeMPID"]);
    }
    return urlEncodedParams;
  }

  /* Remove specific Indexed JsonObject from JsonObject Array */
  removeJsonFieldDetails(tableValues: any, rowIndex: any){
    tableValues.splice(rowIndex, 1);
  }

  /* Add new JsonObject in existing JsonObject Array */
  addJsonFieldDetails(tableValues: any, tableFieldtype: any) {
    let arrObjectDetail = this.constantService.ExportablemultiDimensinalColumns[tableFieldtype].reduce((accumulator: any, currentKey: any) => {
      accumulator[currentKey] = null;
      return accumulator;
    }, {});

    tableValues.push(arrObjectDetail);
  }

}